import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const removeCopDocument = api(async function removeCopDocument({ id }) {
    return mutate(
        gql`
            mutation RemoveCopDocument($id: ID!) {
                removeCopDocument(id: $id)
            }
        `,
        { id },
        { returns: "removeCopDocument" }
    )
})
